import * as firebase from "firebase/app";
import "firebase/firestore";

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyB6wG0opyWRMXQYRTJgS9SviU_9GHxdGbk",
    authDomain: "color-scales.firebaseapp.com",
    databaseURL: "https://color-scales.firebaseio.com",
    projectId: "color-scales",
    storageBucket: "color-scales.appspot.com",
    messagingSenderId: "667039467917",
    appId: "1:667039467917:web:e3db431848ca3ee81ad5c4",
    measurementId: "G-2HW8CDNENY"
});

const db = firebaseApp.firestore();

export default db;
